"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var document_service_1 = require("../../document.service");
require("rxjs/Rx");
var http_1 = require("@angular/common/http");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var index_1 = require("../../model/index");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_policy_client_js_1 = require("@synisys/idm-policy-client-js");
var document_auth_provider_service_1 = require("../../document-auth-provider.service");
var subscription_manager_decorator_1 = require("../../shared/subscription-manager.decorator");
var operators_1 = require("rxjs/operators");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var ErrorObservable_1 = require("rxjs/observable/ErrorObservable");
var NewUpload = /** @class */ (function () {
    function NewUpload(documentService, messageService, classifierService, authenticationService, policyService, documentAuthService) {
        this.documentService = documentService;
        this.messageService = messageService;
        this.classifierService = classifierService;
        this.authenticationService = authenticationService;
        this.policyService = policyService;
        this.documentAuthService = documentAuthService;
        this._metaData = null;
        this.fileUploadAction = new core_1.EventEmitter();
        this.removeDocumentAction = new core_1.EventEmitter();
        this.metaDataUpdateAction = new core_1.EventEmitter();
        this._isUploadInProgress = false;
        this._validationMessage = "";
        this._imageUrl = "";
    }
    NewUpload_1 = NewUpload;
    Object.defineProperty(NewUpload.prototype, "metaData", {
        get: function () {
            return this._metaData;
        },
        set: function (metaData) {
            this._metaData = metaData;
            this.metaDataUpdateAction.emit(this.metaData);
        },
        enumerable: true,
        configurable: true
    });
    NewUpload.prototype.ngOnInit = function () {
        var _this = this;
        if (this.documentId) {
            this.$sm = this.documentService.getIsDocumentPresent(this.documentId).subscribe(function (isConfirmed) {
                if (isConfirmed) {
                    _this.setupConfirmedDocument();
                }
                else {
                    _this.setupTempDocument();
                }
            });
        }
        this.setupDocumentPolicy();
    };
    NewUpload.prototype.onFileChange = function (event) {
        if (event.target.files.length > 0) {
            this._uploadedFile = event.target.files[0];
            this._validationMessage = "";
            this.uploadFile();
        }
    };
    NewUpload.prototype.onDrop = function (event) {
        event.preventDefault();
        if (event.dataTransfer.items) {
            this._uploadedFile = event.dataTransfer.items[0].getAsFile();
        }
        else {
            this._uploadedFile = event.dataTransfer.files[0];
        }
        this._validationMessage = "";
        this.uploadFile();
    };
    NewUpload.prototype.onDragOver = function (event) {
        event.preventDefault();
    };
    NewUpload.prototype.onDragLeave = function (event) {
        event.preventDefault();
    };
    NewUpload.prototype.onClick = function () {
        this._fileUpload.click();
    };
    NewUpload.prototype.cancelFile = function () {
        this.clearFields();
    };
    // TODO refactor
    NewUpload.prototype.downloadFile = function () {
        var _this = this;
        this.$sm = this.documentService.getIsDocumentPresent(this._documentInfo.id).subscribe(function (isConfirmed) {
            if (isConfirmed) {
                _this.$sm = _this.documentAuthService.getDocumentAuthInfo(_this.categoryId, _this.entityId, _this.documentRootName).pipe(operators_1.switchMap(function (authInfo) { return _this.documentService.getDownloadUrl(_this._documentInfo.id, authInfo); })).subscribe(function (url) {
                    _this.documentService.downloadDocument(url, index_1.FileType.ORIGINAL);
                });
            }
            else
                _this.documentService.downloadTempDocument(_this._documentInfo.id);
        });
    };
    NewUpload.prototype.setupConfirmedDocument = function () {
        var _this = this;
        this.$sm = this.documentService.getDocumentInfo(this.documentId).pipe(operators_1.switchMap(function (info) {
            _this._documentInfo = info;
            _this._date = _this._documentInfo.created * 1000;
            _this._size = +_this._documentInfo.size;
            _this.setUserName(_this._documentInfo.userId);
            return _this.documentAuthService.getDocumentAuthInfo(_this.categoryId, _this.entityId, _this.documentRootName);
        })).subscribe(function (authInfo) {
            if (_this.isImage) {
                _this.setImageUrl(authInfo);
            }
            _this._documentPresent = true;
        });
    };
    NewUpload.prototype.setupTempDocument = function () {
        var _this = this;
        this.$sm = this.documentService.getTempDocumentInfo(this.documentId).subscribe(function (info) {
            _this._documentInfo = info;
            _this._date = _this._documentInfo.created * 1000;
            _this._size = +_this._documentInfo.size;
            _this.setUserName(_this._documentInfo.userId);
            if (_this.isImage) {
                _this.setImageUrl();
            }
            _this._documentPresent = true;
        });
    };
    NewUpload.prototype.setImageUrl = function (auth) {
        var _this = this;
        var $url = !!auth ? this.documentService.getDocumentUrl(this._documentInfo.id, auth, index_1.FileType.THUMBNAIL) :
            this.documentService.getTempDocumentUrl(this._documentInfo.id, index_1.FileType.THUMBNAIL);
        this.$sm = $url.subscribe(function (imageUrl) {
            _this._imageUrl = imageUrl;
        });
    };
    NewUpload.prototype.setupDocumentPolicy = function () {
        var _this = this;
        this.$sm = this.authenticationService.getUserData().pipe(operators_1.mergeMap(function (data) {
            var policyOptions$ = _this.filePolicy ? _this.policyService.getPolicyOptions() : of_1.of(null);
            return zip_1.zip(_this.policyService.getUserPolicy(data.userId, NewUpload_1.DOCUMENT_POLICY_KEY), policyOptions$);
        })).subscribe(function (_a) {
            var policy = _a[0], policyOptions = _a[1];
            var policyOption = JSON.parse(policy.policyOptionParam);
            _this.allowedSize = policyOption["maxSize"];
            _this.allowedUserExtensions = _this.getAllowedExtensions(policyOption);
            if (_this.filePolicy) {
                var specifiedPolicy = policyOptions.find(function (policy) { return _this.filePolicy.id === policy.id; });
                _this.allowedFileExtensions = _this.getAllowedExtensions(JSON.parse(specifiedPolicy.policyOptionParam));
            }
        });
    };
    // TODO refactor
    NewUpload.prototype.uploadFile = function () {
        var _this = this;
        this.$sm = this.validate().subscribe(function () {
            _this._isUploadInProgress = true;
            _this.fileUpload(_this._uploadedFile);
        }, function (error) {
            _this.clearFields();
            if (error instanceof http_1.HttpErrorResponse) {
                if (error.status === 400) {
                    if (error.error.hasOwnProperty("type") && error.error.type === "EXTENSION") {
                        _this.$sm = _this.messageService
                            .getMessageWithPlaceholder("document.service.errors.extension", [
                            error.error.currentExtension,
                        ])
                            .subscribe(function (message) { return (_this.validationMessage = message); });
                    }
                    else if (error.error.hasOwnProperty("type") && error.error.type === "SIZE") {
                        _this.$sm = _this.messageService
                            .getMessageWithPlaceholder("document.service.errors.size", [error.error.currentSize])
                            .subscribe(function (message) { return (_this.validationMessage = message); });
                    }
                }
            }
            else {
                _this.validationMessage = error;
            }
        });
    };
    NewUpload.prototype.validate = function () {
        if (!this._uploadedFile) {
            return this.messageService.getMessage("document.service.errors.no_file").pipe(operators_1.map(function (err) { return new ErrorObservable_1.ErrorObservable(err); }));
        }
        if (this.allowedSize && this._uploadedFile.size > this.allowedSize * NewUpload_1.MB_IN_BYTES) {
            return this.messageService
                .getMessageWithPlaceholder("document.service.errors.size_validation", [this.allowedSize.toString()]).pipe(operators_1.switchMap(function (err) { return new ErrorObservable_1.ErrorObservable(err); }));
        }
        if (this.filePolicy && this.isInvalidFileExtension(this.allowedFileExtensions)) {
            return this.messageService
                .getMessageWithPlaceholder("document.service.errors.extension_validation", [this.allowedFileExtensions.map(function (policy) { return policy.extension.toLowerCase(); }).join(", ")]).pipe(operators_1.switchMap(function (err) { return new ErrorObservable_1.ErrorObservable(err); }));
        }
        if (this.isInvalidFileExtension(this.allowedUserExtensions)) {
            return this.messageService
                .getMessageWithPlaceholder("document.service.errors.extension_validation", [this.allowedUserExtensions.map(function (policy) { return policy.extension.toLowerCase(); }).join(", ")]).pipe(operators_1.switchMap(function (err) { return new ErrorObservable_1.ErrorObservable(err); }));
        }
        return this.documentService.validate(this._uploadedFile);
    };
    NewUpload.prototype.fileUpload = function (file) {
        var _this = this;
        this.$sm = this.documentAuthService.getDocumentAuthInfoForUpload(this.categoryId, this.entityId, this.documentRootName).pipe(operators_1.switchMap(function (authInfo) {
            return _this.documentService.uploadAuthWithProgress(_this.categoryId, _this._uploadedFile.name, file, authInfo, _this._metaData);
        })).subscribe(function (event) {
            if (event.type === http_1.HttpEventType.UploadProgress) {
                _this.progressPercent = Math.round(100 * event.loaded / event.total);
            }
            else if (event.type == http_1.HttpEventType.Response) {
                _this._isUploadInProgress = false;
                _this._documentInfo = event.body;
                _this._date = (new Date()).valueOf();
                _this.setUserName(_this._documentInfo.userId);
                if (_this.isImage) {
                    _this.setImageUrl();
                }
                _this._documentPresent = true;
                _this.fileUploadAction.emit(_this._documentInfo.id);
            }
        }, function (error) {
            if (error.status === 404) {
                if (typeof error.error === 'string' && error.error.startsWith("Policy")) {
                    _this._validationMessage = error.error;
                }
            }
        });
    };
    NewUpload.prototype.setUserName = function (userId) {
        var _this = this;
        this.$sm = this.classifierService.loadClassifier("User", userId, false).pipe(operators_1.mergeMap(function (classifier) {
            if (classifier === null || classifier.getId() === null) {
                return of_1.of(null);
            }
            return _this.classifierService.getEntityName("User", classifier);
        })).subscribe(function (userName) { return _this._userName = userName; });
    };
    NewUpload.prototype.getAllowedExtensions = function (policies) {
        var extensions = [];
        for (var policy in policies) {
            if (policy === "maxSize")
                continue;
            extensions = extensions.concat(policies[policy]);
        }
        return extensions;
    };
    NewUpload.prototype.isInvalidFileExtension = function (extensions) {
        var _this = this;
        return !extensions.some(function (extension) {
            return _this._uploadedFile.name.toLowerCase().endsWith(extension.extension.toLowerCase().replace(' ', ''));
        });
    };
    NewUpload.prototype.clearFields = function () {
        if (this._documentInfo != null) {
            this.removeDocumentAction.emit(this._documentInfo.id);
        }
        this._documentPresent = false;
        this._uploadedFile = null;
        this._documentInfo = null;
        this._date = null;
        this._userName = null;
        this._imageUrl = "";
    };
    Object.defineProperty(NewUpload.prototype, "documentPresent", {
        get: function () {
            return this._documentPresent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "isUploadInProgress", {
        get: function () {
            return this._isUploadInProgress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "sizeInKB", {
        get: function () {
            return Math.round(+this._documentInfo.size / NewUpload_1.KB_IN_BYTES);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "isImage", {
        get: function () {
            var _this = this;
            var imageTypes = ["bmp", "gif", "img", "jpe", "jpeg", "jpg", "mac", "pbm", "pct", "png", "ppm", "psd", "tiff"];
            return imageTypes.some(function (value) { return (_this._documentInfo.name).toLowerCase().endsWith(value); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "uploadedFile", {
        get: function () {
            return this._uploadedFile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "validationMessage", {
        get: function () {
            return this._validationMessage;
        },
        set: function (value) {
            this._validationMessage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "date", {
        get: function () {
            return this._date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "userName", {
        get: function () {
            return this._userName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "imageUrl", {
        get: function () {
            return this._imageUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewUpload.prototype, "documentName", {
        get: function () {
            return this._documentInfo.name;
        },
        enumerable: true,
        configurable: true
    });
    NewUpload.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    NewUpload.MB_IN_BYTES = 1048576;
    NewUpload.KB_IN_BYTES = 1024;
    NewUpload.DOCUMENT_POLICY_KEY = "2c191221-9041-11e6-821f-0050568f767f";
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], NewUpload.prototype, "documentId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NewUpload.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], NewUpload.prototype, "height", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NewUpload.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], NewUpload.prototype, "entityId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NewUpload.prototype, "documentRootName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NewUpload.prototype, "filePolicy", void 0);
    __decorate([
        core_1.Input('metaData'),
        __metadata("design:type", Map),
        __metadata("design:paramtypes", [Map])
    ], NewUpload.prototype, "metaData", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NewUpload.prototype, "documentPreviewEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NewUpload.prototype, "showUploadDate", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NewUpload.prototype, "showDocumentSize", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NewUpload.prototype, "showUploadedBy", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NewUpload.prototype, "fileUploadAction", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NewUpload.prototype, "removeDocumentAction", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NewUpload.prototype, "metaDataUpdateAction", void 0);
    NewUpload = NewUpload_1 = __decorate([
        core_1.Component({
            
            selector: "sis-upload-2",
            styles: [require('./sis-upload-2.component.css')],
            template: require('./sis-upload-2.component.html')
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            groups: [
                {
                    identity: "Controls",
                    name: "Controls",
                },
            ],
            template: "\n        <sis-upload-2 class=\"sis-upload-control\"\n                    [id]=\"%{id}\"\n                    [documentId]=\"%{field}\"\n                    [height]=\"%{height}\"\n                    [categoryId]=\"%{categoryId}\"\n                    [entityId]=\"%{entityId}\"\n                    [documentRootName]=\"%{documentRootName}\"\n                    [filePolicy]=\"%{filePolicy}\"\n                    [documentPreviewEnabled]=\"%{documentPreviewEnabled}\"\n                    [showUploadDate]=\"%{showUploadDate}\"\n                    [showDocumentSize]=\"%{showDocumentSize}\"\n                    [showUploadedBy]=\"%{showUploadedBy}\"\n                    (fileUploadAction)=\"%{fileUploadAction}\"\n                    (removeDocumentAction)=\"%{removeDocumentAction}\">\n        </sis-upload-2>",
            iconInfo: "fa-caret-square-o-down",
            name: "NewUpload",
        }),
        subscription_manager_decorator_1.SubscriptionManager(),
        __metadata("design:paramtypes", [document_service_1.DocumentService,
            idm_message_language_service_client_js_1.MessageService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_policy_client_js_1.PolicyService,
            document_auth_provider_service_1.DocumentAuthProviderService])
    ], NewUpload);
    return NewUpload;
    var NewUpload_1;
}());
exports.NewUpload = NewUpload;
//# sourceMappingURL=sis-upload-2.component.js.map